<template>
	<div class="app--engagement-element" :data-id="definition.id" v-show="visible" :class="classes">
		<engagement-text v-if="element && definition.type == 'TEXT'" :definition="definition"
			:element="element"></engagement-text>
		<engagement-textarea v-if="element && definition.type == 'TEXTAREA'" :definition="definition"
			:element="element"></engagement-textarea>
		<engagement-numeric v-if="element && definition.type == 'NUMERIC'" :definition="definition"
			:element="element"></engagement-numeric>
		<engagement-currency v-if="element && definition.type == 'CURRENCY'" :definition="definition"
			:element="element"></engagement-currency>
		<engagement-percentage v-if="element && definition.type == 'PERCENTAGE'" :definition="definition"
			:element="element"></engagement-percentage>
		<engagement-email v-if="element && definition.type == 'EMAIL'" :definition="definition"
			:element="element"></engagement-email>
		<engagement-phone v-if="element && definition.type == 'PHONE'" :definition="definition"
			:element="element"></engagement-phone>
		<engagement-date v-if="element && definition.type == 'DATE'" :definition="definition"
			:element="element"></engagement-date>
		<engagement-year v-if="element && definition.type == 'YEAR'" :definition="definition"
			:element="element"></engagement-year>
		<engagement-dropdown v-if="element && definition.type == 'DROPDOWN'" :definition="definition"
			:element="element"></engagement-dropdown>
		<engagement-option v-if="element && definition.type == 'OPTION'" :definition="definition"
			:element="element"></engagement-option>
		<engagement-address v-if="element && definition.type == 'ADDRESS'" :definition="definition"
			:element="element"></engagement-address>
		<engagement-image v-if="element && definition.type == 'IMAGE'" :definition="definition"
			:element="element"></engagement-image>
		<engagement-document v-if="element && definition.type == 'DOCUMENT'" :definition="definition"
			:element="element"></engagement-document>
		<engagement-encrypted v-if="element && definition.type == 'ENCRYPTED'" :definition="definition"
			:element="element"></engagement-encrypted>
		<engagement-calculated v-if="element && definition.type == 'CALCULATED'" :definition="definition"
			:element="element"></engagement-calculated>

		<engagement-elementtext v-if="element && definition.type == 'ELEMENTTEXT'" :definition="definition"
			:element="element"></engagement-elementtext>
		<engagement-elementimage v-if="element && definition.type == 'ELEMENTIMAGE'" :definition="definition"
			:element="element"></engagement-elementimage>
		<engagement-elementlogo v-if="element && definition.type == 'ELEMENTLOGO'" :definition="definition"
			:element="element"></engagement-elementlogo>
		<engagement-elementbutton v-if="element && definition.type == 'ELEMENTBUTTON'" :definition="definition"
			:element="element"></engagement-elementbutton>
		<engagement-elementdocument v-if="element && definition.type == 'ELEMENTDOCUMENT'" :definition="definition"
			:element="element"></engagement-elementdocument>
		<engagement-elementsum v-if="element && definition.type == 'ELEMENTSUM'" :definition="definition"
			:element="element"></engagement-elementsum>
		<engagement-elementcalendly v-if="element && definition.type == 'ELEMENTCALENDLY'" :definition="definition"
			:element="element"></engagement-elementcalendly>
		<engagement-elementpdf v-if="element && definition.type == 'ELEMENTPDF'" :definition="definition"
			:element="element"></engagement-elementpdf>
		<engagement-elementvideo v-if="element && definition.type == 'ELEMENTVIDEO'" :definition="definition"
			:element="element"></engagement-elementvideo>
		<engagement-elementsignature v-if="element && definition.type == 'ELEMENTSIGNATURE'" :definition="definition"
			:element="element"></engagement-elementsignature>
		<engagement-elementusersig v-if="element && definition.type == 'ELEMENTUSERSIG'" :definition="definition"
			:element="element"></engagement-elementusersig>
	</div>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import { v4 as uuid } from 'uuid'
import store from '../store'
import models from '../store/models'

import ElAddress from './types/Address'
import ElCalculated from './types/Calculated'
import ElCurrency from './types/Currency'
import ElDate from './types/Date'
import ElDocument from './types/Document'
import ElDropdown from './types/Dropdown'
import ElEmail from './types/Email'
import ElEncrypted from './types/Encrypted'
import ElImage from './types/Image'
import ElNumeric from './types/Numeric'
import ElOption from './types/Option'
import ElPercentage from './types/Percentage'
import ElPhone from './types/Phone'
import ElText from './types/Text'
import ElTextarea from './types/Textarea'
import ElYear from './types/Year'
import ElElementButton from './types/ElementButton'
import ElElementDocument from './types/ElementDocument'
import ElElementPdf from './types/ElementPdf'
import ElElementImage from './types/ElementImage'
import ElElementLogo from './types/ElementLogo'
import ElElementSum from './types/ElementSum'
import ElElementText from './types/ElementText'
import ElElementCalendly from './types/ElementCalendly'
import ElElementVideo from './types/ElementVideo'
import ElElementSignature from './types/ElementSignature'
import ElElementUserSig from './types/ElementUserSig'

export default {
	props: {
		panel: { type: Object, required: true },
		group: { type: Object, required: true },
		definition: { type: Object, required: true }
	},
	computed: {
		element() { return store.getters['dataElement'](this.panel, this.group, this.definition) },
		visible() { return store.getters['visibleElement'](this.panel, this.group, this.definition) },
		classes() {
			let c = [];
			if (this.visible) {
				c.push('visible')
			}
			if (store.state.theme.elements.highlight == true) {
				c.push('element--highlight')
			}
			if (this.definition.options && this.definition.options.custom_id) {
				c.push('custom-' + this.definition.options.custom_id)
			}
			if (store.state.complete == true) {
				c.push('closed')
			}

			return c
		},
	},
	watch: {
		element: {
			immediate: true,
			handler(value) {
				if (!this.element) {
					let elid = uuid()
					let value = store.getters['defaultValue'](this.definition.id)

					store.commit('ADD_ELEMENT', models.element({
						id: elid,
						panel: this.panel.id,
						group: this.group.id,
						definition: this.definition.id,
						value: value,
						exists: false
					}))
					if (value) {
						let gk = this.group.id + '|' + this.definition.group
						store.commit('QUEUE', { id: elid, group: gk, value: value, default: true })
					}
				}
			}
		}
	},
	components: {
		'engagement-address': ElAddress,
		'engagement-calculated': ElCalculated,
		'engagement-currency': ElCurrency,
		'engagement-date': ElDate,
		'engagement-document': ElDocument,
		'engagement-dropdown': ElDropdown,
		'engagement-email': ElEmail,
		'engagement-encrypted': ElEncrypted,
		'engagement-image': ElImage,
		'engagement-numeric': ElNumeric,
		'engagement-option': ElOption,
		'engagement-percentage': ElPercentage,
		'engagement-phone': ElPhone,
		'engagement-text': ElText,
		'engagement-textarea': ElTextarea,
		'engagement-year': ElYear,
		'engagement-elementbutton': ElElementButton,
		'engagement-elementcalendly': ElElementCalendly,
		'engagement-elementdocument': ElElementDocument,
		'engagement-elementimage': ElElementImage,
		'engagement-elementlogo': ElElementLogo,
		'engagement-elementpdf': ElElementPdf,
		'engagement-elementsignature': ElElementSignature,
		'engagement-elementsum': ElElementSum,
		'engagement-elementtext': ElElementText,
		'engagement-elementvideo': ElElementVideo,
		'engagement-elementusersig': ElElementUserSig,
	}
}
</script>
